var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58743 8.00017L0.542886 1.95675C0.152371 1.56631 0.152371 0.933275 0.542886 0.542832C0.933402 0.152389 1.56655 0.152389 1.95707 0.542832L8.00161 6.58626L14.0429 0.546061C14.4334 0.155618 15.0666 0.155618 15.4571 0.546061C15.8476 0.936504 15.8476 1.56954 15.4571 1.95998L9.4158 8.00017L15.4568 14.04C15.8473 14.4305 15.8473 15.0635 15.4568 15.4539C15.0663 15.8444 14.4331 15.8444 14.0426 15.4539L8.00161 9.41409L1.95741 15.4572C1.5669 15.8476 0.933746 15.8476 0.543231 15.4572C0.152715 15.0667 0.152715 14.4337 0.543231 14.0433L6.58743 8.00017Z",
    fill: "#E2E2E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.21bb33da02e9af43cb61a5da8a8b40bd.svg";
export { ForwardRef as ReactComponent };